"use strict";

//import loadScript from "../libs/@elements/load-script";
import lightGallery from "lightgallery";
import {preloadSlide} from "./slider";
import {onEnterViewPort} from "../libs/@elements/viewport-utils";
import {closeEntry} from "./hashRouter";
let previewOpen = false;
// let lightgalleryOpen = false;
export function initInScope($scope) {
    let visibleDetailImages = $scope.find('.objekt-detail-images .open-preview');
    let detailGalleryButton = $scope.find('.gallery-button');

    initSlickSlider($scope);

    visibleDetailImages.on('click', function (e) {
        openPreviewGallery($scope);
    });
    detailGalleryButton.on('click', function (e) {
        e.preventDefault();
        openPreviewGallery($scope);
        return false;
    });
    //init lightgallery
    let detailGallery = $scope.find('.detail-gallery');
    $(document).on("touchstart", ".lg-video-object", function () {
        // console.log("clicked video");
        this.pause();


    });
    $(document).on("touchend", ".lg-video-object", function () {
        // console.log("touchend video");



    });

    //init lightgallery on modal
    let previewModal = $scope.find("#galleryPreview");
    let previewItems = previewModal.find('.js-gallery-preview-img');
    let lightboxItems = detailGallery.find('.js-lightbox__item'),
        dataLightboxVideo = false,
        dataLightboxDownload = false,
        videoAutoplay = false;
    let stuffinit = false;

    previewItems.on('click', function (e) {
        e.preventDefault();
        //$("#galleryFull").modal("show");
        let galleryIndex = $(this).data('gallery-index');
        // console.log("index = " + galleryIndex);

        // dataLightboxVideo = $(this).data('lightbox-video');
        dataLightboxDownload = $(this).data('lightbox-download');
        videoAutoplay = $(this).find(".is-video").length > 0;
        // console.log($(this));
        // console.log("videoAutoplay", videoAutoplay);
        let dynamicItems = [];
        lightboxItems.each(function () {
            let src = $(this).attr('href');
            let options = {};
            if (typeof src === 'undefined' || src === '') {
                options["html"] = $(this).data('html');
            } else {
                options["src"] = src;
            }
            // console.log("gallery options");
            // console.log(options);
            dynamicItems.push(options);
        });

        if (detailGallery.data('lightGallery')) {
            detailGallery.data('lightGallery').destroy(true);
            detailGallery.off('onCloseAfter.lg');
            detailGallery.off('onAfterSlide.lg');
        }
        detailGallery.lightGallery({
            dynamic:   true,
            dynamicEl: dynamicItems,
            index: galleryIndex,
            download: dataLightboxDownload || false,
            videojs: dataLightboxVideo || false,
            counter:   true,
            videoAutoplay: videoAutoplay
        });
        let firstSlide = true
        // if(!videoAutoplay) {
        detailGallery.off('onAfterSlide.lg').on('onAfterSlide.lg', function () {
            // console.log("after slide ", firstSlide);
            if(!firstSlide) {
                $(".lg").find('.lg-current video').each(function (e) {
                    // If browser deferred resource, ensure the first frame is available
                    if (this.readyState < 1) {
                        try {
                            this.load();
                        } catch (e) {
                            // console.log(e);
                        }
                    }


                    this.controls = true;

                    // --- key part: rebuild native controls at correct width ---
                    var v = this;
                    // Wait until the next paint (LG just finished a transform)
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            // toggle controls to force re-measure
                            v.controls = false;
                            // force a reflow so the change commits
                            void v.offsetWidth;
                            v.controls = true;
                        });
                    });
                });
            }
            firstSlide = false;
        });
        // }
        detailGallery.on('onCloseAfter.lg', function (event) {
            // no-op when the router already unwound it (browser back, or a
            // cascading close where the modal went away at the same time)
            closeEntry('lightgallery');
        });

        const inst = detailGallery.data('lightGallery');
        inst.index = galleryIndex;
        _config.hashStack.push('lightgallery');
        history.pushState({ hashStack: _config.hashStack }, '', '#lightgallery');
        return false;
    });

    // $(window).on('popstate', function(e) {
    //     if (lightgalleryOpen && (!e.state || !e.state.lightgalleryOpen)) {
    //         $scope.find(".lg-visible .lg-close").trigger("click");
    //         lightgalleryOpen = false;
    //     } else if (previewOpen && (!e.state || !e.state.previewOpen)) {
    //         previewModal.modal("hide");
    //         previewOpen = false;
    //     }
    // });

    // //prevent isClickable
    // lightboxItems.find('img').on('touchstart', function (evt) {
    //     evt.stopPropagation();
    // });
    let videoModal = $scope.find("#videoModal");
    videoModal.on("hide.bs.modal", function (e) {
        $(this).find(".embedded-video-container").html("");
    });
    //init iframe video modals
    let videoTrigger = $scope.find(".js-video-modal-open");
    videoTrigger.on("click", function () {
        // console.log("CLICKED VIDEO normal init");
        videoTriggerCallback();
    });

    // $("body").on("click", ".lg-video", function () {
    //     console.log("CLICKED VIDEO lg vid init");
    //     videoTriggerCallback();
    // })
}
function videoTriggerCallback() {
    let videoModal = $("#videoModal");
    let videoUrl = videoModal.find(".embedded-video-container").data('src');
    if(videoUrl) {
        let videoIframeHtml = getVideoIframeHtml(videoUrl);
        videoModal.modal("show");
        videoModal.find(".embedded-video-container").html(videoIframeHtml);
    }
}
function openPreviewGallery($scope) {
    // hashRouter's show.bs.modal handler pushes #galleryPreview - do NOT push it again here
    $scope.find('#galleryPreview').modal('show');
    previewOpen = true;
}
function initSlickSlider($scope) {
    // console.log("init slick slider");
    let sliderId = 0;
    let $thumbSlider = $scope.find('.js-gallery-slider');

    import('slick-carousel').then(function () {
        $thumbSlider.each(function () {
            let $container = $(this);
            let $mainSlider = $container.find('.js-gallery-slider__main');
            let $thumbSlider = $container.find('.js-gallery-slider__thumbs');
            let id = sliderId++;

            $mainSlider.attr('id', 'main-slider__main-' + id);

            // $thumbSlider.attr('id', 'thumb-slider__thumb-' + id);

            let $counter = $(`
              <div class="slider-counter">
                <span class="current">1</span>
                /
                <span class="total">0</span>
              </div>
            `);
            $container.append($counter);

            $mainSlider.on('init', function (e, slick) {
                // console.log("init slick");
                $counter.find('.total').text(slick.slideCount);
                $counter.find('.current').text(slick.currentSlide + 1);
                //init iframe video modals
                let videoTrigger = $(this).find(".js-video-modal-open");
                videoTrigger.on("click", function () {
                    // console.log("CLICKED VIDEO slick init");
                    videoTriggerCallback();
                })
                // preload first slide:
                // preloadSlide(slick, slick.currentSlide + (matchMedia('(max-width: 767px)').matches ? 2 : 1));
            }).on('afterChange', function (event, slick, currentSlide) {
                // console.log("afterchange");
                $counter.find('.current').text(currentSlide + 1);
                preloadSlide(slick, currentSlide + (matchMedia('(max-width: 767px)').matches ? 2: 1));
            }).slick({
                // asNavFor: '#thumb-slider__thumb-' + id,
                dots: false,
                arrows: false,
                // prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><i class='icon icon-button-arrow'></i></button>",
                // nextArrow:"<button type='button' class='slick-next' aria-label='next'><i class='icon icon-button-arrow'></i></button>",
                infinite: false,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        asNavFor: null,
                        slidesToShow: 1,
                    }
                }]
            }).each(function () {
                let $slider = $(this);
                if($slider.hasClass("mobile")) {
                    onEnterViewPort($slider, function () {
                        preloadSlide(
                            $slider.slick('getSlick'),
                            (matchMedia('(max-width: 767px)').matches ? 2: 1)
                        );
                    });
                }
            });

            // if ($thumbSlider && $thumbSlider.length) {
            //     $thumbSlider.slick({
            //         dots: true,
            //         arrows:false,
            //         infinite: false,
            //         asNavFor: '#main-slider__main-' + id,
            //         focusOnSelect: true,
            //         slidesToShow: $thumbSlider.data('slider-items') || 4
            //     });
            // }

            $container.find('.js-lightbox__item').on('click', function (e) {
                // console.log("clicing mobile");
                e.preventDefault();
                openPreviewGallery($scope);
                return false;
            });
        });
    });
}

function getVideoIframeHtml(videoUrl) {
    return '<iframe\n' +
        '  src="' + videoUrl + '?rel=0&modestbranding=1&playsinline=1"\n' +
        '  allow="fullscreen; encrypted-media; picture-in-picture"\n' +
        '  allowfullscreen\n' +
        '  allowfullscreen\n' +
        '  width="100%"\n' +
        '  height="auto"\n' +
        '  class="pimcore_tag_video video-modal__iframe">\n' +
        '</iframe>\n'
}